<template>
  <div v-if="company" id="page-company-edit">
    <button class="goBack-btn" @click="goBack">
      <i class="fal fa-arrow-left"></i>Zurück
    </button>
    <div class="vx-row w-full company-show">
      <!-- left side -->
      <div class="vx-col w-full lg:w-2/3">
        <div class="card big">
          <!-- card header -->
          <div class="card-header">
            <div class="vx-row">
              <div class="vx-col w-full md:w-7/12 lg:w-7/12">
                <div class="company-show-name">
                  {{ company.name }}
                </div>
                <div class="company-show-infos">
                  <div class="applicant-show-infos">
                    <ul>
                      <li v-if="addressOutput()">
                        <i class="fal fa-map-marker-alt"></i>
                        <template v-if="addressOutput().street"
                          >{{ addressOutput().street }}, &nbsp;
                        </template>
                        <template v-if="addressOutput().zip">
                          {{ addressOutput().zip }}
                          &nbsp;</template
                        >
                        <template v-if="addressOutput().city">
                          {{ addressOutput().city }}</template
                        >
                      </li>
                      <li v-if="addressOutput().email">
                        <i class="fal fa-envelope"></i>
                        <a :href="` mailto:${addressOutput().email} `">
                          {{ addressOutput().email }}</a
                        >
                      </li>
                      <li v-if="addressOutput().telephoneMobile">
                        <i class="fal fa-phone-alt"></i>
                        <a
                          :href="` callto:${addressOutput().telephoneMobile} `"
                        >
                          {{ addressOutput().telephoneMobile }}
                        </a>
                      </li>
                      <li v-else-if="addressOutput().telephone">
                        <i class="fal fa-phone-alt"></i>
                        <a :href="` callto:${addressOutput().telephone} `">
                          {{ addressOutput().telephone }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                v-if="company.landwehrId"
                class="vx-col w-full md:w-5/12 lg:w-5/12"
              >
                <div class="company-landwehr-id-wrapper">
                  <div class="company-show-number">
                    #{{ company.landwehrId }}
                  </div>
                  <div class="landwehr-logo">
                    <img
                      v-if="company.landwehrId"
                      src="@/assets/images/logo/zvoove_icon.svg"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- card body -->
          <div class="card-body">
            <div slot="no-body" class="tabs-container">
              <vs-tabs
                v-model="currentTab"
                class="tab-action-btn-fill-conatiner"
              >
                <vs-tab
                  label="Allgemeine Daten"
                  icon-pack="fal"
                  icon="fa-building"
                >
                  <div v-if="tabs[currentTab] === 'data'" class="tab-text">
                    <CompanyEditGeneralData />
                  </div>
                </vs-tab>
                <vs-tab label="Ansprechpartner" icon-pack="far" icon="fa-user">
                  <div
                    v-if="tabs[currentTab] === 'contactPartner'"
                    class="tab-text"
                  >
                    <CompanyEditContactPartner />
                  </div>
                </vs-tab>
                <vs-tab label="Historie" icon-pack="far" icon="fa-history">
                  <div v-if="tabs[currentTab] === 'history'" class="tab-text">
                    <CompanyEditHistory />
                  </div>
                </vs-tab>
                <vs-tab label="Wiedervorlagen" icon-pack="far" icon="fa-repeat">
                  <div
                    v-if="tabs[currentTab] === 'resubmission'"
                    class="tab-text"
                  >
                    <CompanyEditResubmission />
                  </div>
                </vs-tab>
              </vs-tabs>
            </div>
          </div>
        </div>
      </div>
      <!-- right side -->
      <div class="vx-col w-full lg:w-1/3">
        <!-- historie -->
        <div class="card actions-card">
          <div class="card-body">
            <div class="card-headline">Ansprechpartner</div>
            <div class="actions-card-body">
              <ShortContacts :resource-id="$route.params.id" />
              <div class="actions-card-more" @click="currentTab = 1">
                Vollständige Liste ansehen<i class="fas fa-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- historie -->
        <div class="card actions-card">
          <div class="card-body">
            <div class="card-headline">Historie</div>
            <div class="actions-card-body">
              <ShortActions
                is-history
                type="COMPANY"
                :resource-id="$route.params.id"
              />
              <div class="actions-card-more" @click="currentTab = 2">
                Vollständige Historie ansehen<i class="fas fa-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vs-alert
      color="danger"
      title="Firma nicht gefunden"
      :active.sync="fetchFailed"
    >
      <span>Firma mit ID: {{ $route.params.id }} nicht gefunden.</span>
      <span>
        <span> Gehe zu </span
        ><router-link
          :to="{ name: 'company.overview' }"
          class="text-inherit underline"
          >Alle Firmen</router-link
        >
      </span>
    </vs-alert>
  </div>
</template>

<script>
import CompanyEditContactPartner from "./CompanyEditContactPartner";
import CompanyEditGeneralData from "./CompanyEditGeneralData";
import CompanyEditHistory from "./CompanyEditHistory";
import CompanyEditResubmission from "./CompanyEditResubmission";
import ShortActions from "@/components/company/CompanyShowShortHistory";
import ShortContacts from "@/components/company/CompanyShowShortContacts";
import gql from "graphql-tag";

export default {
  components: {
    CompanyEditContactPartner,
    CompanyEditGeneralData,
    CompanyEditHistory,
    CompanyEditResubmission,
    ShortActions,
    ShortContacts
  },
  apollo: {
    company: {
      query: gql`
        query Company($id: ID!) {
          company(id: $id) {
            id
            l1UpdateRequested
            landwehrId
            name
            name2
            name3
            status
            state {
              id
              name
            }
            active
            postAddress {
              id
              number
              name
              name2
              name3
              street
              zip
              city
              country
              telephone
              telephone2
              fax
              email
              homepage
              salutation
              letterSalutation
            }
            deliveryAddress {
              id
              number
              name
              name2
              name3
              street
              zip
              city
              country
              telephone
              telephone2
              fax
              email
              homepage
              salutation
              letterSalutation
            }
            billingAddress {
              id
              number
              name
              name2
              name3
              street
              zip
              city
              country
              telephone
              telephone2
              fax
              email
              homepage
              salutation
              letterSalutation
            }
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id
        };
      },
      error(error) {
        if (error.gqlError.message === "record not found") {
          this.fetchFailed = true;
        } else {
          this.fetchFailed = true;
          // TODO: Display different error message
        }
      }
    }
  },
  data() {
    return {
      // lastSave: new Date(),
      fetchFailed: false,
      currentTab: 0,
      tabs: ["data", "contactPartner", "history", "resubmission"]
    };
  },
  watch: {
    currentTab(tab) {
      if (this.$route.params.page !== this.tabs[tab]) {
        this.$router.replace({
          name: "company.edit.sub",
          params: { page: this.tabs[tab] }
        });
      }
    }
  },
  mounted() {
    if (this.$route.params.page) {
      this.currentTab = this.tabs.indexOf(this.$route.params.page);
    }
  },
  methods: {
    goBack() {
      return this.$router.go(-1);
    },
    addressOutput() {
      if (this.company.billingAddress) {
        return this.company.billingAddress;
      } else if (this.company.postAddress) {
        return this.company.postAddress;
      } else {
        return null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#page-company-edit {
  padding: 20px 50px;
}
</style>
